import React from "react";
import { Typography, Space, Card, Divider, Image, Col, Row } from "antd";
import { Icon } from "@iconify/react";
import Arrow from "@assets/KPMG/FinancingProducts/rectangle-arrow.svg";

import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";

export const FinancingCard = (props: any) => {
  const { data } = props;
  const navigate = useNavigate();
  return (
    <Card
      bodyStyle={{ padding: "24px 0", paddingLeft: 24 }}
      style={{
        width: "100%",
        borderRadius: "15px",
        height: "100%",
        background: "#F9FBFD",
        border: "1px solid #EDEEF0",
      }}
    >
      <Row>
        <Col span={24}>
          <Fade direction="up" triggerOnce cascade={true} damping={0.1}>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <Typography.Title
                    level={5}
                    style={{ marginBottom: 0, color: "#00338D" }}
                  >
                    {data.title}
                  </Typography.Title>
                </div>
                <div
                  style={{
                    borderTopLeftRadius: 10,
                    borderBottomLeftRadius: 10,
                    background: " #ACEAFF",
                    padding: "4px 12px",
                    minWidth : 80,
                    height : "fit-content"
                  }}
                >
                  <Typography.Text style={{ color: "#003087" }}>
                    Features
                  </Typography.Text>
                </div>
              </div>
              <div style={{ paddingTop: 20 }}>
                <Row gutter={[32, 0]}>
                  <Col span={8}>
                    <img
                      src={data.image}
                      style={{ maxWidth: "100%", width: 80 }}
                    />
                  </Col>
                  <Col span={16}>
                    {data.links.map((item: any) => (
                      <div style={{ display: "flex", paddingBottom: 10 }}>
                        <div>
                          <img src={Arrow} />
                        </div>
                        <div style={{ paddingLeft: 10 }}>
                          <Typography.Link
                            target="_blank"
                            href={item.href}
                            style={{ color: "#1E49E2" }}
                          >
                            {item.title}
                          </Typography.Link>
                        </div>
                      </div>
                    ))}
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
        </Col>
      </Row>
    </Card>
  );
};
